import { Controller } from "@hotwired/stimulus"

// Controls the addon slide-over panel
// - Desktop: right-side slide-over
// - Mobile: bottom sheet
// - Lazy-loads content via Turbo Frame when opened
export default class extends Controller {
  static targets = ["desktopPanel", "desktopBackdrop", "mobilePanel", "mobileBackdrop", "desktopFrame", "mobileFrame"]
  static values = {
    url: String
  }

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    // Load content into the appropriate Turbo Frame
    if (this.isMobile()) {
      this.openMobile()
    } else {
      this.openDesktop()
    }

    // Prevent body scroll
    document.body.classList.add("overflow-hidden")

    // Add listeners
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  openDesktop() {
    if (!this.hasDesktopPanelTarget) return

    // Set the Turbo Frame src to load content
    if (this.hasDesktopFrameTarget && this.urlValue) {
      this.desktopFrameTarget.src = this.urlValue
    }

    // Show backdrop
    if (this.hasDesktopBackdropTarget) {
      this.desktopBackdropTarget.classList.remove("hidden")
      // Trigger reflow for transition
      this.desktopBackdropTarget.offsetHeight
      this.desktopBackdropTarget.classList.add("opacity-100")
      this.desktopBackdropTarget.classList.remove("opacity-0")
    }

    // Show panel
    this.desktopPanelTarget.classList.remove("translate-x-full", "invisible")
    this.desktopPanelTarget.classList.add("translate-x-0")
  }

  openMobile() {
    if (!this.hasMobilePanelTarget) return

    // Set the Turbo Frame src to load content
    if (this.hasMobileFrameTarget && this.urlValue) {
      this.mobileFrameTarget.src = this.urlValue
    }

    // Show backdrop
    if (this.hasMobileBackdropTarget) {
      this.mobileBackdropTarget.classList.remove("hidden")
      // Trigger reflow for transition
      this.mobileBackdropTarget.offsetHeight
      this.mobileBackdropTarget.classList.add("opacity-100")
      this.mobileBackdropTarget.classList.remove("opacity-0")
    }

    // Show panel
    this.mobilePanelTarget.classList.remove("translate-y-full")
    this.mobilePanelTarget.classList.add("translate-y-0")
  }

  close() {
    this.closeDesktop()
    this.closeMobile()

    // Re-enable body scroll
    document.body.classList.remove("overflow-hidden")

    // Remove listeners
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  closeDesktop() {
    if (!this.hasDesktopPanelTarget) return

    // Hide backdrop
    if (this.hasDesktopBackdropTarget) {
      this.desktopBackdropTarget.classList.remove("opacity-100")
      this.desktopBackdropTarget.classList.add("opacity-0")
      setTimeout(() => {
        this.desktopBackdropTarget.classList.add("hidden")
      }, 300)
    }

    // Hide panel
    this.desktopPanelTarget.classList.add("translate-x-full", "invisible")
    this.desktopPanelTarget.classList.remove("translate-x-0")
  }

  closeMobile() {
    if (!this.hasMobilePanelTarget) return

    // Hide backdrop
    if (this.hasMobileBackdropTarget) {
      this.mobileBackdropTarget.classList.remove("opacity-100")
      this.mobileBackdropTarget.classList.add("opacity-0")
      setTimeout(() => {
        this.mobileBackdropTarget.classList.add("hidden")
      }, 300)
    }

    // Hide panel
    this.mobilePanelTarget.classList.add("translate-y-full")
    this.mobilePanelTarget.classList.remove("translate-y-0")
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  isMobile() {
    return window.innerWidth < 1024 // lg breakpoint
  }
}
